import ClaimsStatistics from '../../../reports/claimsnew/ClaimsStatistics';

const InsurancePremiumsChart = () => <ClaimsStatistics />;

export default InsurancePremiumsChart;
